// extracted by mini-css-extract-plugin
module.exports = {"homeSectionIntro":"styles_homeSectionIntro__SIvt6","homeSectionHero":"styles_homeSectionHero__kw3Lj","pageHome":"styles_pageHome__aXvVB"};